import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import LinkBuilder from 'helpers/link-builder';
import LinkCandidateProfile from 'components/LinkCandidateProfile';

const NetworkItemOverviewCandidate = props => {
  const { user, item } = props;

  const {
    CandidateID,
    FirmName,
    FirmUrlAlias,
    FirmActive,
    FullName,
    SchoolName,
    OfficeLocationName,
    RoleName,
    Dates,
    FirmAlumni,
    SchoolAlumni,
    TitleName,
    GroupName,
    IndustryName,
    ViewProfile,
    ViewAsRecruiter,
  } = item;

  const [title, group] = useMemo(
    () => [
      TitleName ? TitleName : null,
      GroupName ? (
        IndustryName ? (
          <div className="network-item__group">
            <span className="network-item__text">{GroupName}</span>
            &nbsp;/&nbsp;
            <span className="network-item__text">{IndustryName}</span>
          </div>
        ) : (
          <span className="network-item__text">{GroupName}</span>
        )
      ) : null,
    ],
    [user]
  );

  const viewProfile = ViewProfile === 'Yes';
  const viewAsRecruiter = ViewAsRecruiter === 'Yes';

  return (
    <div className="network-item__content">
      <LinkCandidateProfile
        cls="network-item__title"
        clsSpan="network-item__title-span"
        user={user}
        id={CandidateID}
        name={FullName}
        viewProfile={viewProfile}
        viewAsRecruiter={viewAsRecruiter}
      />
      <div className="network-item__info">
        {FirmActive === 'Yes' ? (
          <NavLink
            to={LinkBuilder.getFirmLink(FirmUrlAlias)}
            className="network-item__company"
          >
            {FirmName}
          </NavLink>
        ) : (
          <span className="network-item__company-span">{FirmName}</span>
        )}
        <span className="network-item__school">{SchoolName}</span>
        <span className="network-item__location">{OfficeLocationName}</span>
      </div>
      <div className="network-item__profile">
        <div className="network-item__column">
          {RoleName && (
            <div className="network-item__group">
              <span className="network-item__text">{RoleName}</span>
            </div>
          )}
          {Dates && (
            <div className="network-item__group">
              <span className="network-item__text">{Dates}</span>
            </div>
          )}
        </div>
        <div className="network-item__column">
          {group}
          {title && (
            <div className="network-item__group">
              <span className="network-item__text">{title}</span>
            </div>
          )}
        </div>
        <div className="network-item__column">
          {FirmAlumni && (
            <div className="network-item__group">
              <span className="network-item__text">
                Firm Network:{FirmAlumni}
              </span>
            </div>
          )}
          {SchoolAlumni && (
            <div className="network-item__group">
              <span className="network-item__text">
                School Network:{SchoolAlumni}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

NetworkItemOverviewCandidate.propTypes = {
  user: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default NetworkItemOverviewCandidate;
